import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";

const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

const setHead = (tag, attrs) => {
  const sel = Object.entries(attrs).filter(([k]) => k === "rel" || k === "name").map(([k, v]) => `[${k}="${v}"]`).join("");
  let el = document.head.querySelector(`${tag}${sel}`);
  const created = !el;
  if (created) { el = document.createElement(tag); document.head.appendChild(el); }
  const prev = {};
  Object.entries(attrs).forEach(([k, v]) => { prev[k] = el.getAttribute(k); el.setAttribute(k, v); });
  return () => { if (created) el.remove(); else Object.entries(prev).forEach(([k, v]) => (v == null ? el.removeAttribute(k) : el.setAttribute(k, v))); };
};

export const useFotoPwaHead = () => {
  useEffect(() => {
    const undo = [
      setHead("link", { rel: "manifest", href: "/foto.webmanifest" }),
      setHead("link", { rel: "apple-touch-icon", href: "/foto/apple-touch-icon.png" }),
      setHead("meta", { name: "theme-color", content: "#f59e0b" }),
      setHead("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
      setHead("meta", { name: "apple-mobile-web-app-title", content: "PatroGestPro Foto" }),
    ];
    if ("serviceWorker" in navigator) navigator.serviceWorker.register("/foto-sw.js", { scope: "/foto" }).catch(() => {});
    return () => undo.forEach((f) => f());
  }, []);
};

export const FotoInstallButton = () => {
  const [prompt, setPrompt] = useState(null);
  const [ios] = useState(() => !isStandalone() && isIos());
  const [installed, setInstalled] = useState(isStandalone);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => { setInstalled(true); setPrompt(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  if (installed || (!prompt && !ios)) return null;
  const click = async () => {
    if (prompt) { prompt.prompt(); await prompt.userChoice.catch(() => {}); setPrompt(null); }
    else setOpen(true);
  };

  return (
    <div className="mt-4" data-testid="foto-install-wrap">
      <button type="button" onClick={click} data-testid="foto-install-app-btn"
        className="w-full h-12 inline-flex items-center justify-center gap-2 rounded-xl border-2 border-amber-500 text-amber-700 bg-white active:bg-amber-50 text-base font-semibold transition-colors">
        <Download className="h-5 w-5" />Installa App
      </button>
      {open && ios && (
        <div className="mt-3 relative rounded-xl border border-slate-200 bg-white p-3 pr-9 text-sm text-slate-700 flex flex-wrap items-center gap-1 pgp-fade-up" data-testid="foto-ios-install-hint">
          Per installare: tocca <Share className="h-4 w-4" /> Condividi poi Aggiungi a schermata Home
          <button type="button" onClick={() => setOpen(false)} title="Chiudi" data-testid="foto-install-info-close"
            className="absolute top-2 right-2 p-1 rounded-md text-slate-500 hover:bg-slate-100"><X className="h-4 w-4" /></button>
        </div>
      )}
    </div>
  );
};
